import { useEffect } from 'react';

export const SITE_URL = 'https://alphapro-genetics.pl';

const setMeta = (selector, attributes) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('meta');
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
};

const setLink = (selector, attributes) => {
  let element = document.head.querySelector(selector);
  if (!element) {
    element = document.createElement('link');
    document.head.appendChild(element);
  }
  Object.entries(attributes).forEach(([name, value]) => element.setAttribute(name, value));
};

const Seo = ({ title, description, path, noIndex = false, structuredData }) => {
  useEffect(() => {
    const canonical = `${SITE_URL}${path}`;
    document.title = title;
    setMeta('meta[name="description"]', { name: 'description', content: description });
    setMeta('meta[name="robots"]', { name: 'robots', content: noIndex ? 'noindex,follow' : 'index,follow' });
    setMeta('meta[property="og:title"]', { property: 'og:title', content: title });
    setMeta('meta[property="og:description"]', { property: 'og:description', content: description });
    setMeta('meta[property="og:type"]', { property: 'og:type', content: 'website' });
    setMeta('meta[property="og:url"]', { property: 'og:url', content: canonical });
    setMeta('meta[name="twitter:card"]', { name: 'twitter:card', content: 'summary_large_image' });
    setLink('link[rel="canonical"]', { rel: 'canonical', href: canonical });

    const schemaId = 'seo-structured-data';
    let schema = document.getElementById(schemaId);
    if (structuredData) {
      if (!schema) {
        schema = document.createElement('script');
        schema.id = schemaId;
        schema.type = 'application/ld+json';
        document.head.appendChild(schema);
      }
      schema.textContent = JSON.stringify(structuredData);
    } else if (schema) {
      schema.remove();
    }
  }, [description, noIndex, path, structuredData, title]);

  return null;
};

export default Seo;
